import humanizeDuration from 'humanize-duration';

const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: 'shortEn',
  languages: {
    shortEn: {
      d: () => 'business days',
      h: () => 'hrs',
      m: () => 'min',
    },
  },
});

export default function humanizeMinutes(
  valueMins: number,
  isDefaultFormat: boolean = false,
): string {
  if (valueMins <= 0) {
    return '';
  }

  if (isDefaultFormat) {
    return humanizeDuration(valueMins * 60 * 1000);
  }

  const humanized = shortEnglishHumanizer(
    valueMins * 60 * 1000,
    { units: ['d', 'h', 'm'] },
  );

  return humanized;
}

